import { Injectable, Inject } from '@angular/core';
import { failStatus, successStatus } from '../models/request-status.model';
import { Observable } from 'rxjs';
import { TranslationService } from '@spartacus/core';
import { RecaptchaRequest } from './recaptcha.model';
import { RECAPTCHA_V3_SITE_KEY } from './recaptcha.token';

declare const grecaptcha: any;

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  private scriptLoaded = false;
  private scriptFailed = false;

  constructor(
    @Inject(RECAPTCHA_V3_SITE_KEY) private siteKey: string,
    private translationService: TranslationService,
  ) {
    this.loadRecaptchaScript();
  }

  private loadRecaptchaScript(): void {
    if (document.querySelector(`script[src*="recaptcha/api.js"]`)) {
      this.scriptLoaded = true;
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${this.siteKey}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      this.scriptLoaded = true;
    };

    script.onerror = () => {
      this.scriptLoaded = false;
      this.scriptFailed = true;
    };

    document.head.appendChild(script);
  }

  getToken(action: string): Observable<RecaptchaRequest> {
    return new Observable(observer => {
      if (this.scriptFailed) {
        this.translationService.translate('generic.error').subscribe(textError => {
          observer.next({
            message: textError,
            ...failStatus,
          });
          observer.complete();
        });
        return;
      }

      const checkReady = () => {
        if (typeof grecaptcha === 'undefined' || !this.scriptLoaded) {
          setTimeout(checkReady, 100);
          return;
        }

        grecaptcha.ready(() => {
          grecaptcha
            .execute(this.siteKey, { action })
            .then((token: string) => {
              observer.next({
                ...successStatus,
                token,
              });
              observer.complete();
            })
            .catch(() => {
              this.translationService.translate('generic.error').subscribe(textError => {
                observer.next({
                  message: textError,
                  ...failStatus,
                });
                observer.complete();
              });
            });
        });
      };

      checkReady();
    });
  }
}
